import { render, staticRenderFns } from "./common_CostumePage.vue?vue&type=template&id=d00a7054&"
import script from "./common_CostumePage.vue?vue&type=script&lang=js&"
export * from "./common_CostumePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports